import { Grid } from "@mui/material";
import React, { useMemo } from "react";
import { useSelector } from "react-redux";
import { SELECTED_SURVEY_ITEM_FIELDS } from "../surveyUtils";
import FormField from "../../../../../components/common/FormField";

const SelectedSurveyItem = () => {
  const { surveyedItems } = useSelector((state: any) => state.leadSurvey);

  // ─── Flatten all items from all categories ──────────────────────────────────
  const allSurveyedItems: any[] = useMemo(
    () => surveyedItems?.list?.map((cat: any) => cat.items).flat() || [],
    [surveyedItems]
  );

  console.log("All Surveyed Items:", allSurveyedItems);
  // ─── Build formData — each key maps to the field id in SELECTED_SURVEY_ITEM_FIELDS
  const formData = useMemo(() => {
    // Helper: join items into readable multiline string
    const joinItems = (items: any[]) =>
      items.map((it: any) => `${it.item} x ${it.quantity}`).join(" || ");

    return {
      // Items flagged as "Company Dismantle"
      we_dismantle: joinItems(
        allSurveyedItems.filter((it: any) => it.isWeee)
      ),

      // Items flagged as "Leave - do NOT take"
      leave_items: joinItems(
        allSurveyedItems.filter((it: any) => it.isLeave)
      ),

      // Items flagged as "Awkward"
      awkward_items: joinItems(
        allSurveyedItems.filter((it: any) => it.isAwk)
      ),

      // Items flagged as "Export Wrap"
      export_wrap_items: joinItems(
        allSurveyedItems.filter((it: any) => it.isExp)
      ),

    // Items flagged as "Customer"
    customer_items:joinItems(
        allSurveyedItems.filter((it: any) => it.isCust)
      ),
      // isStore items
      store_items: joinItems(
        allSurveyedItems.filter((it: any) => it.isStore)
      ),
    };
  }, [allSurveyedItems]);

  return (
    <>
      <Grid
        container
        spacing={0.5}
        sx={{
          border: "1px solid #CFCFCF",
          padding: "0px 10px 10px 0px",
          background: "#E5F4F1",
          borderRadius: "5px",
        }}
      >
        {SELECTED_SURVEY_ITEM_FIELDS?.map((field, i) => {
          const fieldValue = formData[field.id as keyof typeof formData] || "";

          // ─── Skip rendering if no value ─────────────────────────────────────
          if (!fieldValue) return null;

          return (
            <FormField
              key={field.id}
              onPaste={(e: any) => e.preventDefault()}
              onFocus={(e: any) => e.target.blur()}
              onKeyDown={(event: any) => {
                if (
                  event.keyCode === 8 ||
                  event.keyCode === 9 ||
                  event.keyCode === 37 ||
                  event.keyCode === 38 ||
                  event.keyCode === 39 ||
                  event.keyCode === 40 ||
                  event.keyCode === 18 ||
                  event.keyCode === 17 ||
                  event.ctrlKey
                )
                  return;
              }}
              {...{
                ...field,
                multiline: true,
                rows: fieldValue.split("\n").length + 1, // auto height based on item count
                inSingleGridForm: true,
                value: fieldValue,
                variant: "outlined",
                disabled: true,
                isNonMarginTop: true,
                disableTextFillColor: true,
                GridFieldStyle: {
                  paddingRight: "0px",
                },
                InputProps: {
                      ...(field?.inputProps && field?.inputProps),

                      ...{
                        disabled: field?.editReadOnly,
                      },

                      sx:
                        field?.type === "text" || field?.type === "password"
                          ? { height: "36px", padding: "10px 0px 10px 4px" }
                          : { padding: "10px 4px", height: "36px" },
                    },
              }}
            />
          );
        })}
      </Grid>
    </>
  );
};

export default SelectedSurveyItem;